

/// <reference path="StockNote.ts" />

// Generated class TransferNote_ManagedObject

class TransferNote_ManagedObject extends StockNote
{
    // Relationship: destinationPlace
    set destinationPlace(value:Place) {
        this.setValueForKey(value, 'destinationPlace');
    }
    get destinationPlace():Place {
        return this.valueForKey('destinationPlace') as Place;
    }
    // Relationship: originPlace
    set originPlace(value:Place) {
        this.setValueForKey(value, 'originPlace');
    }
    get originPlace():Place {
        return this.valueForKey('originPlace') as Place;
    }
}
